import React, {Component} from 'react';
import moment from 'moment';
import Flatpickr from 'react-flatpickr';
import firebase from 'firebase'
import { db } from '../firebase/firebase.js';
import './form.css'
import { Button } from 'semantic-ui-react'
import geo from 'html5-geolocation'

import '../../node_modules/flatpickr/dist/themes/material_blue.css'

class Form extends Component {

  constructor() {
    super();
    this.state = {
      tags: new Set(),
      eventType: '',
      startDate: new Date(),
      endDate: new Date(),
      location : [0,0]
    };

     geo().on('position', (position) => {

            this.setState({location: position})
        })
        .on('error', (error) => {
            // this.setState({})
        })
        .highAccuracy(true)
        .watch()
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleClick(id, event) {
    event.preventDefault();
    if (this.state.tags.has(id)) { // if clicked already
      // unclick
      this.state.tags.delete(id)
    } else {
        this.state.tags.add(id)
        // click it (style)
    }
    console.log(this.state.tags)

  }

  handleSubmit(event){
    alert('Your favorite type is: ' + this.state.eventType);
    console.log(this.state)
    event.preventDefault();
    db.collection("events")
      .add(this.state).
      then((ref) => {
        console.log(`Ref id: ${ref.id}`)
      })

  }


  handleInputChange(event) {
    const target = event.target;
    const type = target.type;
    switch(type){
      case "select":
        const value = target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
        break;
    }
  }

  handleStartDateChange(date) { this.setState({ startDate: date }) }
  handleEndDateChange(date) { this.setState({ endDate: date }) }

  render() {
    return (
      <form style={{"display": "flex",
        "flexWrap": "nowrap",
        "flexDirection": "column",
        "flex": "1 1 0px"}}
        onSubmit={this.handleSubmit}>


        <label>
          What type of the event is this?


        </label>

  <div className="choice"> 
  <a className="choiceButton"
  onClick={this.handleClick.bind(this, "#freeFood")}>Food </a> 
  <a className="choiceButton"
  onClick={this.handleClick.bind(this, "#freeMusic")}>Music </a> 
  <a className="choiceButton"
  onClick={this.handleClick.bind(this, "#freeSwag")}>Swag </a> 
  </div>
     
      <label>Enter in Location</label>

      <input type="text"/>

      Event Start Date:
      <Flatpickr data-enable-time
        value={this.state.startDate}
        className='buttonstyle'
        onChange={this.handleStartChange}
        
      />
      Event End Date:
      <Flatpickr data-enable-time
        value={this.state.endDate}
        onChange={this.handleEndChange}
        className='buttonstyle'
        title={"Event End Date"}
      />
       <div className = 'centerbutton'>
        <Button style={{justifyContent: 'center'}}>Spread the Word!</Button>
        </div>
      </form>
    );
  }
}

export default Form;